var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 43.3333C31.841 43.3333 33.3333 41.8409 33.3333 40C33.3333 38.159 31.841 36.6667 30 36.6667C28.1591 36.6667 26.6667 38.159 26.6667 40C26.6667 41.8409 28.1591 43.3333 30 43.3333Z",
    stroke: "current",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 43.3333C51.841 43.3333 53.3333 41.8409 53.3333 40C53.3333 38.159 51.841 36.6667 50 36.6667C48.1591 36.6667 46.6667 38.159 46.6667 40C46.6667 41.8409 48.1591 43.3333 50 43.3333Z",
    stroke: "current",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25C36.6667 21.6667 43.3333 21.6667 55 25",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 55C35 58.3333 45 58.3333 56.6667 55",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6667 56.6667C51.6667 60 56.6667 66.6667 58.3333 66.6667C63.3333 66.6667 67.7767 61.11 70 56.6667C72.2233 51.11 71.6667 37.2233 65 18.3333C60.1433 14.95 55 13.8667 50 13.3333L46.6667 21.6667",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 56.6667C28.3333 60 23.8133 66.6667 22.2267 66.6667C17.4633 66.6667 13.2333 61.11 11.1167 56.6667C9 51.11 9.53 37.2233 15.8767 18.3333C20.5033 14.95 25.15 13.8667 30 13.3333L33.3333 21.6667",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.a5c153bc40b1ffaf0561383b062d1692.svg";
export { ForwardRef as ReactComponent };